const routes = [
  {
    path: 'cssmix',
    component: () => import(/* webpackChunkName: "cssmix" */ '@/modules/cssmix/index.vue'),
    children: [
      {
        path: '',
        name: 'cssmix',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/cssmix/demo1.vue'),
      },
      {
        path: 'demo1',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/cssmix/demo1.vue'),
      },
      // {
      //   path: 'demo2',
      //   component: () => import(/* webpackChunkName: "demo2" */ '@/modules/cssmix/demo2.vue'),
      // },
    ],
  },
];

export default routes;